import { useSyncExternalStore } from 'react';

const subscribeToVisibilityChange = (onChange: () => void) => {
    document.addEventListener('visibilitychange', onChange);
    return () => document.removeEventListener('visibilitychange', onChange);
};

const getIsPageVisible = () => document.visibilityState === 'visible';

const usePageVisibility = () => useSyncExternalStore(subscribeToVisibilityChange, getIsPageVisible);

export default usePageVisibility;
